/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdMedalsIssued200Ok
 */
export interface GetCorporationsCorporationIdMedalsIssued200Ok {
    /**
     * ID of the character who was rewarded this medal
     * @type {number}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    characterId: number;
    /**
     * issued_at string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    issuedAt: Date;
    /**
     * ID of the character who issued the medal
     * @type {number}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    issuerId: number;
    /**
     * medal_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    medalId: number;
    /**
     * reason string
     * @type {string}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    reason: string;
    /**
     * status string
     * @type {string}
     * @memberof GetCorporationsCorporationIdMedalsIssued200Ok
     */
    status: GetCorporationsCorporationIdMedalsIssued200OkStatusEnum;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdMedalsIssued200OkStatusEnum = {
    Private: 'private',
    Public: 'public'
} as const;
export type GetCorporationsCorporationIdMedalsIssued200OkStatusEnum = typeof GetCorporationsCorporationIdMedalsIssued200OkStatusEnum[keyof typeof GetCorporationsCorporationIdMedalsIssued200OkStatusEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdMedalsIssued200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdMedalsIssued200Ok(value: object): value is GetCorporationsCorporationIdMedalsIssued200Ok {
    if (!('characterId' in value) || value['characterId'] === undefined) return false;
    if (!('issuedAt' in value) || value['issuedAt'] === undefined) return false;
    if (!('issuerId' in value) || value['issuerId'] === undefined) return false;
    if (!('medalId' in value) || value['medalId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdMedalsIssued200OkFromJSON(json: any): GetCorporationsCorporationIdMedalsIssued200Ok {
    return GetCorporationsCorporationIdMedalsIssued200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMedalsIssued200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdMedalsIssued200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'characterId': json['character_id'],
        'issuedAt': (new Date(json['issued_at'])),
        'issuerId': json['issuer_id'],
        'medalId': json['medal_id'],
        'reason': json['reason'],
        'status': json['status'],
    };
}

export function GetCorporationsCorporationIdMedalsIssued200OkToJSON(json: any): GetCorporationsCorporationIdMedalsIssued200Ok {
    return GetCorporationsCorporationIdMedalsIssued200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMedalsIssued200OkToJSONTyped(value?: GetCorporationsCorporationIdMedalsIssued200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'character_id': value['characterId'],
        'issued_at': ((value['issuedAt']).toISOString()),
        'issuer_id': value['issuerId'],
        'medal_id': value['medalId'],
        'reason': value['reason'],
        'status': value['status'],
    };
}

